import { Observable } from 'rxjs'
import { MbDataImageFigureEntries } from '../../../models'

export abstract class MbProductDataImagesTabAdapter {

  abstract load(productCode: string, maxCount?: number): Observable<MbDataImageFigureEntries>
}
